const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.theme.carousel.plugins

class ProductCarousel extends HTMLElement {
  constructor() {
    super()

    this.els = {
      slides: this.querySelector('[data-product-carousel-el="slides"]'),
      slide: this.querySelectorAll('[data-product-carousel-el="slide"]'),
      previous: this.querySelector('[data-product-carousel-el="previous"]'),
      next: this.querySelector('[data-product-carousel-el="next"]'),
    }
  }

  connectedCallback () {
    if (this.els.slide.length < 3) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide) return

    return new KeenSlider(
      '[data-product-carousel-el="slides"]',
      {
        selector: this.els.slide,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.01,
          spacing: 4,
        },
        breakpoints: {
          '(min-width: 762px)': {
            slides: {
              perView: 2.23,
              spacing: 12,
            },
          },
          '(min-width: 1100px)': {
            slides: {
              perView: 2.85,
              spacing: 12,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next,
          previous: this.els?.previous,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}